"use client"

import { App, ConfigProvider, theme } from "antd"
import useTheme from "hooks/useTheme"

export default function AntdConfigProvider({ children }: { children: React.ReactNode }) {
  const { theme: selectedTheme } = useTheme()

  const algorithm = selectedTheme === "dark" ? theme.darkAlgorithm : theme.defaultAlgorithm

  return (
    <ConfigProvider theme={{ algorithm }}>
      <App>{children}</App>
    </ConfigProvider>
  )
}
